import { render } from "./VersionIcon.vue?vue&type=template&id=29f4b622"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/VersionIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29f4b622"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29f4b622', __exports__)) {
    api.reload('29f4b622', __exports__)
  }
  
  module.hot.accept("./VersionIcon.vue?vue&type=template&id=29f4b622", () => {
    api.rerender('29f4b622', render)
  })

}


export default __exports__